export default "__VITE_ASSET__Cl04zAAv__"